export function canPerformHeadActions(session: {
  roleCode?: string
  authority?: string
}): boolean {
  if (session.roleCode === 'HEAD_WAREHOUSE') return true
  if (session.roleCode === 'ASSISTANT_HEAD_WAREHOUSE') return session.authority === 'full'
  return false
}
